import {Component} from '@angular/core';
import {RoutesEnum} from '../../../core/services/navigation/routes.enum';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {Utils} from '@astek/utils';
import {finalize} from 'rxjs';
import {NavigationService} from '../../../core/services/navigation/navigation.service';
import {SensorUdiEnum} from '../enum/sensor-udi.enum';
import {SensorRestApiService} from '../services/http/sensor-rest-api.service';
import {ApiBatchCreateSensorRequest} from '../services/http/api-batch-create-sensor-request';
import {TranslocoService} from '@jsverse/transloco';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'xp-batch-create-sensor',
  templateUrl: './batch-create-sensor.component.html',
  styleUrls: ['../../crud.common.scss'],
})
export class BatchCreateSensorComponent {

  public readonly formGroup = this._formBuilder.group({
    udi: new FormControl<string>(SensorUdiEnum.LUER, Validators.required.bind(Validators)),
    numberOfSensors: new FormControl<number>(1, Validators.required.bind(Validators)),
  }, {validators: []});

  public isLoading: boolean = false;
  public errorKey: string = '';

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly _sensorRestApiService: SensorRestApiService,
    private readonly _navigationService: NavigationService,
    private readonly _translocoService: TranslocoService,
    private readonly _snackBar: MatSnackBar,
  ) {
  }

  public get sensorListRoute(): Array<string> {
    return ['/', RoutesEnum.SENSORS];
  }

  public get udiList(): Array<{ key: string, value: SensorUdiEnum }> {
    return Object.entries(SensorUdiEnum).map(([key, value]) => {
      return {
        key: key,
        value: value,
      };
    });
  }

  public onSubmit(): void {
    if (this.formGroup.invalid ||
      Utils.isBlank(this.formGroup.controls.udi.value) ||
      Utils.isNull(this.formGroup.controls.numberOfSensors.value)
    ) {
      return;
    }
    this.isLoading = true;
    this.errorKey = '';
    const data: ApiBatchCreateSensorRequest = {
      udi: this.formGroup.controls.udi.value,
      numberOfSensors: this.formGroup.controls.numberOfSensors.value,
    };
    this._sensorRestApiService.requestBatchCreate(data).pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: async () => {
          const messageKey = 'SENSORS.BATCH_CREATE.SUCCESS';
          this._snackBar.open(
            this._translocoService.translate(messageKey),
            '',
            {duration: 7000},
          );
          await this._navigationService.navigateTo(RoutesEnum.SENSORS);
        },
        error: () => this.errorKey = 'SHARED.ERRORS.UNKNOWN',
      });
  }
}
